import { Spinner } from 'baseui/spinner'
import { styled, withStyle } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    backgroundColor: $theme.colors.white,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 100
}))

export const InnerContainer = styled('div', ({ $theme }) => ({
    position: 'relative',
    transform: 'translateY(-50%)',
    top: '33%',

    [$theme.mediaQuery.large]: {
        top: '40%'
    }
}))

export const LoadingSpinner = withStyle(Spinner, ({ $theme }) => ({
    borderWidth: '6px',
    borderTopColor: $theme.colors.primary100,
    margin: 'auto',
    borderLeftColor: $theme.colors.primary300,
    borderRightColor: $theme.colors.primary300,
    borderBottomColor: $theme.colors.primary300,
    width: '10rem',
    height: '10rem',

    [$theme.mediaQuery.large]: {
        width: '12rem',
        height: '12rem',
        borderWidth: '8px'
    }
}))

export const Title = styled('p', ({ $theme }) => ({
    ...$theme.typography.HeadingXLarge,
    color: $theme.colors.primary,
    marginBottom: '4.5rem',
    textAlign: 'center',
    marginTop: 0
}))
